<template>
  <div>
    <div class="style-container">
      <div class="px-3 mb-5 d-flex flex-column">
        <i class="bi bi-exclamation-circle style-icon"></i>
        <span>Looks like the path you entered is not valid.</span>
      </div>
    </div>

    <!-- Homepage Button -->
    <div class="scss-button-position-bottom">
      <default-button title="Home" @click="goToHomePage" />
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
export default {
  name: "PageNotFound",
  components: { DefaultButton },
  methods: {
    goToHomePage() {
      this.$router.push("/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-icon {
  color: #f23648;
  font-size: 70px;
}
</style>
